import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { banners } from "@/mocks/comics";

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % banners.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + banners.length) % banners.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 6000);
    return () => clearInterval(timer);
  }, [next]);

  const banner = banners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0 transition-opacity duration-700">
        <img
          src={banner.image}
          alt={banner.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      </div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full mb-4">
                {banner.badge}
              </span>
              <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
                {banner.title}
              </h1>
              <p className="text-sm md:text-base text-white/80 mb-6 leading-relaxed max-w-xl">
                {banner.description}
              </p>
              <Link
                to={`/article/${banner.slug}`}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 text-white transition-colors cursor-pointer z-10"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        type="button"
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 text-white transition-colors cursor-pointer z-10"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
        {banners.map((_, index) => (
          <button
            key={index}
            type="button"
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === current ? "bg-white w-6" : "bg-white/50 hover:bg-white/70"
            }`}
            aria-label={`第 ${index + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}